import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Eye, MessagesSquare, Mail, Newspaper, FolderKanban, Package, FileText } from "lucide-react";

const Card = ({ icon: Icon, label, value, accent, testid }) => (
  <div className="bg-ll-card rounded-2xl p-6 gold-border card-hover" data-testid={testid}>
    <div className="flex items-center justify-between">
      <div>
        <div className="text-white/50 text-sm">{label}</div>
        <div className="font-syne font-extrabold text-3xl text-white mt-1">{value}</div>
      </div>
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${accent}`}><Icon className="w-6 h-6" /></div>
    </div>
  </div>
);

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  const c = stats?.content || {};

  return (
    <div>
      <h1 className="font-syne font-bold text-3xl text-white mb-1">Dashboard</h1>
      <p className="text-white/50 mb-8">Ringkasan statistik & konten situs PT Lotus Lentera.</p>
      {!stats ? <div className="text-gold">Memuat statistik…</div> : (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            <Card icon={Eye} label="Total Kunjungan" value={stats.visits} accent="btn-gold" testid="stat-visits" />
            <Card icon={MessagesSquare} label="Percakapan Chat AI" value={stats.chat_conversations} accent="bg-[#00F0FF]/20 text-[#00F0FF]" testid="stat-chats" />
            <Card icon={Mail} label="Pesan Masuk" value={stats.contacts} accent="bg-white/10 text-white" testid="stat-contacts" />
            <Card icon={FileText} label="Dokumen Dibuat" value={(stats.invoices||0)+(stats.receipts||0)+(stats.letters||0)} accent="btn-gold" testid="stat-docs" />
          </div>
          <h2 className="font-syne font-bold text-xl text-white mt-10 mb-4">Ringkasan Konten</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            <Card icon={Newspaper} label="Berita" value={c.news || 0} accent="bg-white/10 text-gold" />
            <Card icon={FolderKanban} label="Portofolio" value={c.portfolio || 0} accent="bg-white/10 text-gold" />
            <Card icon={Star} value={c.testimonials || 0} label="Testimoni" accent="bg-white/10 text-gold" />
            <Card icon={Package} label="Produk & Layanan" value={(c.products || 0) + (c.services || 0)} accent="bg-white/10 text-gold" />
          </div>
        </>
      )}
    </div>
  );
}

function Star(props) { return <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15 9 22 9 17 14 19 21 12 17 5 21 7 14 2 9 9 9" /></svg>; }
